import { forwardRef, type Ref, type SVGProps } from "react";

function SvgShiftBookedSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 101 68" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_3299_2093)">
        <circle
          cx="50.5"
          cy="34.0009"
          r="28.4091"
          stroke="url(#paint0_linear_3299_2093)"
          strokeWidth="11.3636"
        />
        <path
          d="M42.2931 35.465L47.5961 40.8886L59.9699 26.4258"
          stroke="#0C1C43"
          strokeWidth="0.852273"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M17.5313 1.68531C17.5313 1.38018 17.2832 1.13281 16.9773 1.13281C16.6713 1.13281 16.4233 1.38018 16.4233 1.68531C16.4233 3.9839 15.9146 5.51282 14.9486 6.47624C13.9826 7.43966 12.4496 7.94698 10.1449 7.94698C9.83894 7.94698 9.59091 8.19434 9.59091 8.49948C9.59091 8.80462 9.83894 9.05198 10.1449 9.05198C12.4496 9.05198 13.9826 9.55929 14.9486 10.5227C15.9146 11.4861 16.4233 13.0151 16.4233 15.3136C16.4233 15.6188 16.6713 15.8661 16.9773 15.8661C17.2832 15.8661 17.5313 15.6188 17.5313 15.3136C17.5313 13.0151 18.0399 11.4861 19.0059 10.5227C19.9719 9.55929 21.5049 9.05198 23.8097 9.05198C24.1156 9.05198 24.3636 8.80462 24.3636 8.49948C24.3636 8.19434 24.1156 7.94698 23.8097 7.94698C21.5049 7.94698 19.9719 7.43966 19.0059 6.47624C18.0399 5.51282 17.5313 3.9839 17.5313 1.68531Z"
        fill="#0D2B57"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3299_2093"
          x1="50.5"
          y1="5.59179"
          x2="50.5"
          y2="62.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clip0_3299_2093">
          <rect x="22.0909" y="5.5918" width="56.8182" height="56.8182" rx="28.4091" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgShiftBookedSmall);
export default ForwardRef;
